export default "__VITE_ASSET__B4cnsY6t__"